import { Navigate, Outlet, useLocation } from "react-router-dom";
import React, { useMemo } from "react";
import { useStateContext } from "state";
import { messages } from "router";
import DynataLogo from "core/widgets/dynataLogo";
import paths from "paths";
import "scss/login.scss";

export const AuthLayout: React.FC = () => {
  const { tokens } = useStateContext();
  const location = useLocation();
  const matchRoute = useMemo(
    () =>
      messages.find((message) => {
        return location.pathname.includes(message.path);
      }),
    [location],
  );

  const redirect =
    location.state?.redirect || `/${paths.authenticated.DASHBOARD}`;

  return tokens && location.pathname == "/login" ? (
    <Navigate to={redirect} />
  ) : (
    <div className="login-wrapper">
      <div className="welcome-message">
        <div className="login-title headline bold m">
          {matchRoute?.header ?? "how you got here?"}
        </div>
        <div className="title regular xxl">
          {matchRoute?.message ?? "You should play by the rules"}
        </div>
      </div>
      <div className="login-form">
        <div style={{ width: "33%", marginBottom: "32px" }}>
          <DynataLogo />
        </div>

        <Outlet />
      </div>
    </div>
  );
};
